export const arrayToIndexedObject = (arr) => {
  return arr
    .map((label, index) => {
      return { index, label };
    })
    .reduce((acc, { index, label }) => {
      acc[index] = label;

      return acc;
    }, {});
};
